// @ts-strict
import cx from "classnames";
import { ReactNode } from "react";

import useCopyToClipboard from "@/hooks/use-copy-to-clipboard";
import { Icon } from "./Icon";

const InlineCode = ({
  children,
  isShellCommand = false
}: {
  children: ReactNode | undefined;
  isShellCommand?: boolean;
}) => {
  const { copied, copy } = useCopyToClipboard();
  const handleCopy = (textToCopy: string) => {
    copy(textToCopy);
  };
  const code = Array.isArray(children) ? children[0] : children;
  return (
    <div
      role="button"
      tabIndex={0}
      className={cx(
        "group relative inline-flex gap-1 items-center bg-hex-eeeeee rounded box-border",
        "px-1 cursor-pointer border border-solid border-transparent hover:border-blue-300",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#4f46e5]",
        "transition duration-150 ease-in-out",
        copied && "border-green-300 hover:border-green-300"
      )}
      data-testid="inline-code"
      onClick={() => handleCopy(code)}
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleCopy(code);
        }
      }}
    >
      <code className="bg-hex-eeeeee text-gray-600 text-xs p-0">
        {isShellCommand && "$ "}
        {code}
      </code>
      <Icon
        className={cx(
          "cursor-pointer text-gray-200 transition duration-150 ease-in-out group-hover:text-blue-300",
          copied && "text-green-300 group-hover:text-green-300"
        )}
        name={copied ? "check" : "copy"}
        width="12px"
      />
      <div
        className={cx(
          "absolute h-fit py-1 flex items-center gap-1 bottom-full rounded-t right-1 px-1 bg-blue-300",
          "transition duration-150 ease-in-out opacity-0 group-hover:opacity-100",
          copied && "bg-green-300 opacity-100"
        )}
      >
        <span className="text-white text-[10px] leading-3 font-sans font-semibold">
          {copied ? "Copied!" : "Click to copy"}
        </span>
      </div>
    </div>
  );
};

export default InlineCode;
